import styles from "./Login.module.scss";
import { useState } from "react";
import Toggle from "../../components/shared/Toggle/Toggle";
import PhoneEmailInput from "../../components/shared/PhoneEmailInput/PhoneEmailInput";
import Button from "../../components/shared/Button/Button";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import { useLogin } from "../../hooks/useLogin";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../constants/routes";
import LinkGuide from "../../components/shared/LinkGuide/LinkGuide";

const Login = () => {
  const [error, setError] = useState("");
  const [checked, setChecked] = useState(JSON.parse(localStorage.getItem("rememberMe") as string) || false);
  const [inputValue, setInputValue] = useState(checked ? (localStorage.getItem("contact") as string) : "");

  const { loginStepOne } = useLogin();
  const { t, i18n } = useTranslation();

  const checkedHandler = (value: any) => {
    setChecked(value.target.checked);

    if (value.target.checked) {
      localStorage.setItem("rememberMe", "true");
    }

    if (!value.target.checked) {
      localStorage.removeItem("rememberMe");
    }
  };

  const inputValueHandler = (e: any) => {
    const value = e.target.value.trim();
    setInputValue(value);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!value || emailRegex.test(value)) {
      setError("");
    } else {
      setError("Please enter a valid email address");
    }
  };

  const dirData = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <div className={styles.loginPageWrapper}>
      <Header className={styles.headerWrapper} />
      <div className={styles.loginPageContentWrapper}>
        <div className={styles.loginTitle}>{t("login")}</div>
        <div className={styles.loginDesc}>{t("loginTitle")}</div>
        <PhoneEmailInput dirData={dirData} value={inputValue} setValue={inputValueHandler} error={error} />
        <div dir={dirData} className={styles.rememberWrapper}>
          <Toggle checked={checked} setChecked={checkedHandler} />
          <p>{t("rememberMe")}</p>
        </div>
        <Link to={"/confirmation"} className={styles.loginButtonWrapper}>
          <Button
            disabled={!!error}
            className={styles.loginButton}
            title={t("getCode")}
            submit={() => loginStepOne({ emailOrPhone: inputValue })}
          />
        </Link>
        <div className={styles.privacy}>
          <div>
            {t("loginTerms1")}
            {t("loginTerms2")}
            {t("loginTerms3")}
          </div>
          <div>
            {t("loginTerms4")}
            <Link to={ROUTES.AGREEMENT}>{t("loginTerms5")}</Link>
          </div>
        </div>
      </div>
      <div style={{ height: "50px" }} />
      <Footer source={""} />
      <LinkGuide/>
    </div>
  );
};

export default Login;
